
import Home from "components/FrontEnd/Home";
import HowItWorks from "components/FrontEnd/HowItWorks";
import AboutUs from "components/FrontEnd/AboutUs";
import commentGallery from "components/FrontEnd/commentGallery";
import PrivacyContact from "components/FrontEnd/PrivacyContact";
import Dashboard from "components/FrontEnd/Dashboard";

const FrontEndRoutes = [

  {
    path          : "/Home",
    name          : "Home",
    component     : Home,
    showMenu      : true,
    number        : 1
  },
  {
    path          : "/How_It_Works",
    name          : "How it works",
    component     : HowItWorks,
    showMenu      : true,
    number        : 2
  },
  {
    path          : "/Adjudicator_Comments",
    name          : "Music Director Login",
    component     : commentGallery,
    showMenu      : true,
    number        : 3
  },
  {
    path          : "/Dashboard",
    name          : "Dashboard",
    component     : Dashboard,
    showMenu      : true,
    number        : 4
  },
  {
    path          : "/About_Us",
    name          : "About Us",
    component     : AboutUs,
    showMenu      : true,
    number        : 5
  },
  {
    path          : "/privacycontact",
    name          : "Privacy Contact",
    component     : PrivacyContact,
    showMenu      : false,
    number        : 6
  },
  {
    path          : "/",
    name          : "Home",
    component     : Home,
    showMenu      : false,
    number        : 0
  }
];

export default FrontEndRoutes;



// WEBPACK FOOTER //
// ./src/routes/FrontEndRoutes.jsx